<mwe-form [formModel]="formModel()" (formChanged)="onFormChanged($event)" />
